export class TextFieldMaxLengths {
    public static readonly DEFAULT = 255;
    public static readonly ACTING_FOR_REASON_MAX_LENGTH = 1000;
    public static readonly FORMATTED_PHONE_NUMBER_LENGTH = 14;
    public static readonly PHONE_EXTENSION_MAX_LENGTH = 6;
}